import { useReady } from '@/composables/ready'
import { useLogger } from '@booksy-com/vue-tools'

const logger = useLogger('router.guard.app-is-ready')

const { whenReady } = useReady()

export default function (route, from, next) {
  logger.debug(route.path)

  whenReady.then(() => {
    next()
  }).catch(e => {})
}
